/** The methods listed below are global methods available
 *  under Vue.$app.methodName(), e.g. this.$app.getToken()
 */
import Vue from "vue";
import { store } from "@/store/store";
import { config } from "@/config.js";
import Buefy from "buefy";
import globals from "./globals.js";

Vue.use(Buefy);

const BASE_URL = config.huddlelabsApiBaseUrl;
const BASIC_AUTH = btoa(`${config.huddlelabsApiUsername}:${config.huddlelabsApiPassword}`);

export default {
  editToken(val) {
    store.commit("app/EDIT_AMADEUS_TOKEN", val);
  },
  async getToken() {
    let sol = {};
    let raw = { environment: config.amadeusEnvironment };

    try{
      let result = await this.$app.huddleLabsServerCall("amadeus/access-token", raw);
      if(result.access_token){
        sol.access_token = result.access_token;
      }
    }
    catch(error){
      sol.error = error;
    }

    return sol;
  },
  setSessionKey(key) {
    store.dispatch("app/alterSession", key);
  },
  logout() {
    // console.log("logout");
    //localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("loginExpireTime");
    store.dispatch("clearState/clearState");
  },
  isMobileVersion() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },
  previewMode() {
    return config.previewMode ? true : false;
  },
  async logEvent(eventData) {

    // Append user data if available
    
    // getCurrentTravellerProfile
    if (store.getters["travellersAndTrips/getCurrentTravellerProfile"]) {
      eventData.user_id = store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].id;
    } else if (store.getters["travellersAndTrips/getLoggedInUserProfile"]) {
      eventData.user_id = store.getters[
        "travellersAndTrips/getLoggedInUserProfile"
      ].id;
    }

    // Append the app_id to all requests
    eventData.app_id = 'tripcircuit';

    if (this.previewMode()) {
      console.log("logEvent: ", eventData);
    } else {
      this.huddleLabsServerCall("analytics/log-event", eventData);
    }

    return;
  },
  async huddleLabsServerCall(type = null, body = null, headers = {}, additionalData = []) {
    const fullUrl = type ? `${BASE_URL}${type}` : BASE_URL;
    
    const myHeaders = new Headers({
      'Authorization': `Basic ${BASIC_AUTH}`,
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      ...headers
    });
  
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow',
      body: body ? JSON.stringify(body) : undefined
    };
  
    try {
      const response = await fetch(fullUrl, requestOptions);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return { ...data, error: false };
    } catch (error) {
      console.error('API call failed:', error);
      return {
        error: true,
        status: error.status,
        message: error.message
      };
    }
  },

  //Form Data Calls
  async huddleLabsServerCall1(
    type = null,
    body = null,
    headers = {},
    additionalData = []
  ) {
    let baseUrl = config.huddlelabsApiBaseUrl;
    let username = config.huddlelabsApiUsername;
    let password = config.huddlelabsApiPassword;
    let basicAuth = btoa(username + ":" + password);

    let fullUrl;

    if (type) {
      fullUrl = baseUrl + type;
    } else {
      fullUrl = baseUrl;
    }

    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Basic ${basicAuth}`);
    myHeaders.append("X-Requested-With", "XMLHttpRequest");

    let urlencoded = new URLSearchParams();
    urlencoded.append("environment", "production");
    for (const val of Object.keys(headers)) {
      myHeaders.append(val, headers[val]);
    }

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      processData: false

    };

    if (body) {
    //  requestOptions.body = JSON.stringify(body);
      requestOptions.body = body;

    }

    //// console.log('requestOptions: ', requestOptions);

    let sol;
    await fetch(`${fullUrl}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        // console.log('API result:', result);
        sol = JSON.parse(result);
        sol.error = false;
      })
      .catch((error) => {
        // console.log('error', error);
        sol = { error: true };
      });
    return sol;
  },
};
